(ns rothko.theme.sandi.layout
  (:require [clojure.string :as string]
            [garden.units :refer [px]]
            [rothko.theme.sandi.header :as header]))

(def main
  {:main
   {:grid-area "main"
    :layout-item-width "100%"}

   :container
   {:width "100vw"
    :height "100%"
    :display :grid
    :grid-template-columns " auto minmax(min-content, 1090px) auto"
    :grid-template-rows "auto 1fr auto"
    :grid-template-areas [["\"header header header\""
                           "\"left-gutter main right-gutter\""
                           "\"footer footer footer\""]]
    :layout-item-flex-grow 0}

   :column
   {:flex-direction :column
    :layout-item-flex-grow 1}

   :centered
   {:align-items :center
    :layout-item-flex-grow 1
    :justify-content :center}})
